import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'finance_subject',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_finance_subject');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.width = '500px';
        this.modalConfig.title = val.name || '查看';

        this.openModal();
      }
    },
  },
};
